import { Component, OnInit } from "@angular/core";
import { BlobService } from "@merri/common";
import { PRODUCT_NAME } from "src/app/core";
import { LEARN_MORE_VENUE_LINK } from "src/app/shared";

@Component({
    selector: "app-homepage-venue-join",
    templateUrl: "./homepage-venue-join.component.html",
    styleUrls: ["./homepage-venue-join.component.scss"],
    standalone: false
})
export class HomepageVenueJoinComponent implements OnInit {
  imageUrl: string;
  readonly LEARN_MORE_VENUE_LINK = LEARN_MORE_VENUE_LINK;
  readonly PRODUCT_NAME = PRODUCT_NAME;

  constructor(private blobService: BlobService) {}

  ngOnInit(): void {
    this.imageUrl = this.blobService.getAssetBlobUrl("homepage_venue_join.png");
  }
}
